module.exports = __webpack_public_path__ + "img/recent-reports.svg";